const GRADE_TO_AGGREGATE = {
  // PLE canonical codes
  D1: 1,
  D2: 2,
  C3: 3,
  C4: 4,
  C5: 5,
  C6: 6,
  P7: 7,
  P8: 8,
  F9: 9,
  // Legacy / alternate labels
  A1: 1,
  A: 1,
  B2: 2,
  'A-': 2,
  'B+': 2,
  B3: 3,
  B: 3,
  'B-': 4,
  'C+': 5,
  C: 6,
  'C-': 7,
  'D+': 8,
  D: 8,
  'D-': 8,
  F: 9
};

const DEFAULT_PLE_DIVISION_BANDS = [
  { division: 'Division 1', min: 4, max: 12 },
  { division: 'Division 2', min: 13, max: 23 },
  { division: 'Division 3', min: 24, max: 29 },
  { division: 'Division 4', min: 30, max: 34 },
  { division: 'Division U', min: 35, max: 36 },
  { division: 'Division X', min: 37, max: 99 }
];

const normalizeGradeCode = (grade) => {
  if (grade == null) return null;
  const normalized = String(grade).trim().toUpperCase().replace(/\s+/g, '');
  return normalized || null;
};

export const aggregateFromGradeCode = (grade) => {
  const normalized = normalizeGradeCode(grade);
  if (!normalized) return null;

  if (Object.prototype.hasOwnProperty.call(GRADE_TO_AGGREGATE, normalized)) {
    return GRADE_TO_AGGREGATE[normalized];
  }

  const trailingDigit = normalized.match(/([1-9])$/);
  if (trailingDigit) {
    return Number(trailingDigit[1]);
  }

  return null;
};

export const resolveSubjectAggregate = (subject) => {
  const numericAggregate = Number(subject?.subject_aggregate);
  if (Number.isFinite(numericAggregate) && numericAggregate > 0) {
    return Math.trunc(numericAggregate);
  }

  return aggregateFromGradeCode(subject?.subject_grade || subject?.final_grade || null);
};

export const computePleAggregateTotal = (subjectsData, bestSubjectsCount = 4) => {
  if (!Array.isArray(subjectsData) || subjectsData.length === 0) return null;

  const limit = Number(bestSubjectsCount);
  const bestCount = Number.isInteger(limit) && limit > 0 ? limit : 4;

  const aggregates = subjectsData
    .map((subject) => resolveSubjectAggregate(subject))
    .filter((value) => Number.isInteger(value) && value > 0)
    .sort((a, b) => a - b);

  if (aggregates.length === 0) return null;

  return aggregates.slice(0, bestCount).reduce((sum, value) => sum + value, 0);
};

export const resolvePleDivision = (aggregateTotal, divisionBands = DEFAULT_PLE_DIVISION_BANDS) => {
  const total = Number(aggregateTotal);
  if (!Number.isFinite(total)) return null;

  const matchedBand = divisionBands.find((band) => total >= Number(band.min) && total <= Number(band.max));
  return matchedBand?.division || null;
};

